import { combineReducers } from "redux";
import user from "./user";
import time from "./time";
import editing from "./editing";
import edited from "./edited";
import dailytexts from "./dailytexts";
import send from "./send";

export default combineReducers({
  user,
  time,
  send,
  editing,
  edited,
  dailytexts
});



// WEBPACK FOOTER //
// ./src/store/reducers/index.js